import type {ProfileModelType} from "#shared-package/profile-model.ts";

import type {ProfileDropdownData} from "./user-dropdown.tsx";

export const TRIGGLESS_MODAL_FOCUS_ANCHOR_ID = "triggerless-modal-focus-anchor";
export const PARENT_KHANMIGO_TOOLS_PATH: string = "/parent/khanmigo-tools";

// Remove the HTML tags from a string (while leaving the text inside the tags).
export const removeHTMLTags = (string = ""): string => {
    return string
        .replace(/<[^>]*>/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
};

// Returns a profile data object required for the Profile/User menu.
// TODO(LP-8552): Update UserSettings to use WithUserProfile instead.
export const getProfileDropdownData = (
    profile: ProfileModelType | null,
): ProfileDropdownData | null => {
    if (!profile) {
        return null;
    }

    const isPhantom = profile.get("isPhantom");
    const hasStudents = profile.get("hasStudents");
    const hasClasses = profile.get("hasClasses");
    const hasChildStudents = profile.get("hasChildStudents");
    const hasChildren = hasStudents && hasChildStudents;

    const baseData = {
        profileUrl: profile.get("profileRoot"),
        nickName: profile.get("nickname"),
        isPhantom,
        showSignUpToSave: isPhantom && !profile.get("isMidsignupPhantom"),
        hasStudents,
        hasChildren,
        showSettings: !isPhantom,
    } as const;

    return {
        ...baseData,
        showTeacherLinks: profile.get("isTeacher") || hasClasses,
        showParentLinks: profile.get("isParent") || hasChildren,
        showAdministratorLinks: profile.get("canAccessDistrictsHomepage"),
    };
};
